var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentIllustrationsGiftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "80px",
    viewBox: "0 0 73 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "content-illustrations-gift-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrations-/-Institutional-admin",
    transform: "translate(-48, -5498)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content/Illustrations/Gift/Blue",
    transform: "translate(48, 5498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-2",
    transform: "translate(0, 1.7597)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "36.5 78.2402542 72.2436497 57.5436881 72.2436497 32.1006966 73 31.6656483 73 21.1071734 36.5 42.219235"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.45,
    transform: "translate(36.5, 21.1072)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 57.1330808 35.7436497 36.4365147 35.7436497 10.9935232 36.5 10.5584749 36.5 0 0 21.1120616"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.15,
    points: "36.5 52.7728217 50.1875 44.8588537 72.2436497 32.1006966 72.2436497 33.6209214 36.5 54.2881584"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "36.5 78.2402542 0.951537433 57.6952218 0.951537433 32.2131248 0 31.6656483 0 21.1071734 36.5 42.219235"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3,
    points: "36.5 78.2402542 0.951537433 57.6952218 0.951537433 32.2131248 0 31.6656483 0 21.1071734 36.5 42.219235"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.1,
    points: "0.946657754 32.2131248 36.5 52.7728217 36.5 54.2881584 0.946657754 33.7480142"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "0 21.1071734 36.5 0 73 21.1071734 36.5 42.219235"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.6,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 21.1071734 36.5 0 73 21.1071734 36.5 42.219235"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBEBEB",
    points: "21.6755348 69.6712697 21.6755348 33.6453623 15.7467246 30.2187462 15.7467246 66.2446536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "21.6755348 69.6712697 21.6755348 33.6453623 15.7467246 30.2187462 15.7467246 66.2446536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.4,
    points: "21.6755348 69.6712697 21.6755348 33.6453623 15.7467246 30.2187462 15.7467246 66.2446536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "51.3244652 69.6712697 51.3244652 33.6453623 57.2532754 30.2187462 57.2532754 66.2446536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.15,
    points: "51.3244652 69.6712697 51.3244652 33.6453623 57.2532754 30.2187462 57.2532754 66.2446536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "15.7467246 30.2187462 52.2467246 9.10668459 58.1755348 12.5381889 21.6755348 33.6453623"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.25,
    points: "36.0169118 25.3550043 30.0881016 21.9234999 36.0169118 18.4968838 41.9457219 21.9234999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "51.3244652 33.6453623 14.8244652 12.5381889 20.7532754 9.10668459 57.2532754 30.2187462"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "35.0751337 26.122449 43.4681818 39.9560064 43.4681818 64.0596358 48.6601604 56.7078089 48.6601604 36.9742148 36.2901738 23.5757057"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "path_fill",
    fill: "#264FAE",
    points: "36.514639 24.6706587 60.6934492 25.4185507 64.8655749 19.787364 36.4609626 22.3487718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0677807,13.7455701 C13.0677807,13.7455701 14.5316845,19.6113895 21.3290775,21.8746181 C28.1264706,24.1378468 36.0022727,24.6755469 36.0022727,24.6755469 L20.5580882,6.21288036 L13.0677807,13.7455701 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0677807,13.7455701 C13.0677807,13.7455701 14.5316845,19.6113895 21.3290775,21.8746181 C28.1264706,24.1378468 36.0022727,24.6755469 36.0022727,24.6755469 L20.5580882,6.21288036 L13.0677807,13.7455701 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0022727,24.6755469 C36.0022727,24.6755469 36.1681818,18.8928266 33.1866979,14.5227912 C30.2052139,10.1527557 20.5580882,6.21288036 20.5580882,6.21288036 C17.7464949,8.38856334 15.2286938,10.9206108 13.0677807,13.7455701 C13.0677807,13.7455701 25.8915775,13.6429182 34.7042781,24.4751314 L36.0022727,24.6755469 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0022727,24.6755469 C36.0022727,24.6755469 36.1681818,18.8928266 33.1866979,14.5227912 C30.2052139,10.1527557 20.5580882,6.21288036 20.5580882,6.21288036 C17.7464949,8.38856334 15.2286938,10.9206108 13.0677807,13.7455701 C13.0677807,13.7455701 25.8915775,13.6429182 34.7042781,24.4751314 L36.0022727,24.6755469 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1143717,15.2315777 C23.507087,16.0104152 25.7924624,17.0877602 27.9166444,18.4382256 L32.6157754,13.7895637 C31.0493984,11.9564952 28.4582888,10.2456312 26.0721257,8.90138091 L21.1143717,15.2315777 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0022727,24.6755469 C34.5733199,27.2816582 32.35081,29.36247 29.6586898,30.614689 C25.0229947,32.8681413 17.2643048,32.7508249 17.2643048,32.7508249 L16.5225936,22.9744592 C18.3324488,25.7274991 21.4054031,27.3815161 24.6960561,27.3738238 C28.1794949,27.3981714 31.5528577,26.1524562 34.1870321,23.8689967 L36.0022727,24.6755469 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0022727,24.6755469 C34.5733199,27.2816582 32.35081,29.36247 29.6586898,30.614689 C25.0229947,32.8681413 17.2643048,32.7508249 17.2643048,32.7508249 L16.5225936,22.9744592 C18.3324488,25.7274991 21.4054031,27.3815161 24.6960561,27.3738238 C28.1794949,27.3981714 31.5528577,26.1524562 34.1870321,23.8689967 L36.0022727,24.6755469 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0022727,24.6755469 C31.146992,19.7189295 26.6040107,19.2398876 22.4611631,20.2077478 C17.8742647,21.283148 16.5177139,22.9597947 16.5177139,22.9597947 L17.2594251,32.7361603 C17.2594251,32.7361603 19.6992647,27.9555175 26.325869,25.8047171 C32.9524733,23.6539167 36.0022727,24.6755469 36.0022727,24.6755469 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0022727,24.6755469 C31.146992,19.7189295 26.6040107,19.2398876 22.4611631,20.2077478 C17.8742647,21.283148 16.5177139,22.9597947 16.5177139,22.9597947 L17.2594251,32.7361603 C17.2594251,32.7361603 19.6992647,27.9555175 26.325869,25.8047171 C32.9524733,23.6539167 36.0022727,24.6755469 36.0022727,24.6755469 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7916444,21.4493462 C19.9188503,23.0722229 21.7194519,25.7265062 22.8466578,27.4031529 C23.9459848,26.751084 25.1125092,26.2200706 26.325869,25.8193816 C27.4753527,25.4479037 28.6451396,25.1427068 29.8294786,24.9052915 L25.6134358,19.8020286 C24.5511614,19.8231899 23.4942754,19.9592184 22.4611631,20.2077478 C21.198077,20.4921584 19.9681966,20.9082941 18.7916444,21.4493462 L18.7916444,21.4493462 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7290107,23.5854821 C35.7290107,23.5854821 42.5605615,22.6078455 47.2792112,17.5339118 C51.997861,12.459978 53.0225936,5.3770011 53.0225936,5.3770011 L44.4245989,0 C45.8705942,4.44622745 45.309315,9.30306023 42.8875,13.3007454 C39.8279412,18.5311011 35.5679813,19.6016131 35.5679813,19.6016131 L35.7290107,23.5854821 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7290107,23.5854821 C35.7290107,23.5854821 42.5605615,22.6078455 47.2792112,17.5339118 C51.997861,12.459978 53.0225936,5.3770011 53.0225936,5.3770011 L44.4245989,0 C45.8705942,4.44622745 45.309315,9.30306023 42.8875,13.3007454 C39.8279412,18.5311011 35.5679813,19.6016131 35.5679813,19.6016131 L35.7290107,23.5854821 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7290107,23.5854821 L36.9879679,23.3264084 C37.7086177,18.3792807 40.0825095,13.8231156 43.7219251,10.402053 C49.9874332,4.65355004 53.0225936,5.3770011 53.0225936,5.3770011 C50.5046791,2.8449224 47.5280749,1.2807039 44.4245989,0 C44.4245989,0 39.0959893,3.11866064 36.7391043,7.53268972 C33.9137701,12.8168153 34.8409091,20.6476842 35.7290107,23.5854821 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7290107,23.5854821 L36.9879679,23.3264084 C37.7086177,18.3792807 40.0825095,13.8231156 43.7219251,10.402053 C49.9874332,4.65355004 53.0225936,5.3770011 53.0225936,5.3770011 C50.5046791,2.8449224 47.5280749,1.2807039 44.4245989,0 C44.4245989,0 39.0959893,3.11866064 36.7391043,7.53268972 C33.9137701,12.8168153 34.8409091,20.6476842 35.7290107,23.5854821 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(36.5244, 2.3708)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8917781,4.47268728 L4.63569519,0 C4.28923797,0.288402786 3.94278075,0.591470121 3.58656417,0.923866553 L10.6718583,5.24990835 C11.1012701,4.96150556 11.5111631,4.68776732 11.8917781,4.47268728 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5934492,6.01735305 L2.57647059,1.9357204 C1.90704712,2.64347397 1.30124604,3.40899681 0.766109626,4.22338995 L0.717312834,4.29182451 C0.536764706,4.57045093 0.365975936,4.85885372 0.22934492,5.14725651 C0.141510695,5.31834291 0.0829545455,5.51387022 0,5.6898448 L5.85561497,9.39019919 C6.2703877,8.93071001 6.7144385,8.47610901 7.19752674,8.03128437 C8.06122995,7.23939875 8.85173797,6.58438226 9.5934492,6.01735305 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.9437166,24.6657705 C35.9437166,24.6657705 38.1493316,26.870341 43.3266711,27.994623 C48.5040107,29.118905 54.9744652,28.1363803 57.6729278,24.9590615 L56.8141043,15.8768178 C56.8141043,15.8768178 52.6761364,21.8404008 46.4252674,23.0331174 C41.6627005,23.9374313 35.8802807,22.2216791 35.8802807,22.2216791 L35.9437166,24.6657705 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9437166,24.6657705 C35.9437166,24.6657705 38.1493316,26.870341 43.3266711,27.994623 C48.5040107,29.118905 54.9744652,28.1363803 57.6729278,24.9590615 L56.8141043,15.8768178 C56.8141043,15.8768178 52.6761364,21.8404008 46.4252674,23.0331174 C41.6627005,23.9374313 35.8802807,22.2216791 35.8802807,22.2216791 L35.9437166,24.6657705 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5777406,22.5834046 C35.5777406,22.5834046 40.393984,17.2064035 45.7372326,16.228767 C52.9737968,14.894293 56.833623,15.8768178 56.833623,15.8768178 C58.2194519,19.117683 58.4634358,22.13858 57.6924465,24.9590615 C57.6924465,24.9590615 54.4474599,21.6742026 47.0791444,21.6350972 C41.2528075,21.6057681 35.9632353,24.6657705 35.9632353,24.6657705 L35.5777406,22.5834046 Z",
    id: "Path",
    className: "path_fill",
    fill: "#264FAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5777406,22.5834046 C35.5777406,22.5834046 40.393984,17.2064035 45.7372326,16.228767 C52.9737968,14.894293 56.833623,15.8768178 56.833623,15.8768178 C58.2194519,19.117683 58.4634358,22.13858 57.6924465,24.9590615 C57.6924465,24.9590615 54.4474599,21.6742026 47.0791444,21.6350972 C41.2528075,21.6057681 35.9632353,24.6657705 35.9632353,24.6657705 L35.5777406,22.5834046 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1211898,23.849444 C54.5160758,22.9553901 52.7726056,22.3374202 50.963369,22.0212636 L49.8215241,15.6666259 C51.6223698,15.494553 53.4348334,15.4814674 55.2379679,15.6275205 C56.0696599,18.2832268 56.3698052,21.0772832 56.1211898,23.849444 L56.1211898,23.849444 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.15,
    points: "48.6601604 36.9742148 43.4681818 39.9560064 43.4681818 64.0596358 48.6601604 56.7078089"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIllustrationsGiftBlue);
export default __webpack_public_path__ + "static/media/content-illustrations-gift-blue.a20e5eba.svg";
export { ForwardRef as ReactComponent };